import React from 'react';
import { GraduationCap, Briefcase, MapPin, Bus } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  GraduationCap: GraduationCap,
  Briefcase: Briefcase,
  MapPin: MapPin,
  Bus: Bus
};

const Services = () => {
  return (
    <section id="hizmetler" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Hizmetlerimiz
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Her türlü ulaşım ihtiyacınız için profesyonel çözümler sunuyoruz
          </p>
          <div className="w-20 h-1 bg-blue-500 mx-auto mt-6 rounded-full"></div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-slate-800/50 border border-slate-700 rounded-xl p-8 hover:border-blue-500/50 hover:bg-slate-800 transition-all duration-300"
              >
                <div className="w-14 h-14 bg-blue-600/20 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-600/30 transition-colors duration-300">
                  <IconComponent className="w-7 h-7 text-blue-400" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {service.title}
                </h3>
                <p className="text-slate-400 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
